<script>
import { beforeUpdate, onMount } from "svelte";
import {docs} from "../store.js";
import superagent from 'superagent';

    export let params;
    let ip = "https://vps-1858514-x.dattaweb.com/arteflordepiel";
    const authCode = 'YXJ0ZTpmbG9y';

    let cargando = true;
    let caja = null;
    let nota = null;
    let estabaDia = false;
    let register = [];
    let trabajadores = {};
    let now = new Date(), month, day, year;
	let dateString;
    let selectedDate = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
    let selectedLocal = '';

    function parsedDate(){
        month = '' + (now.getMonth() + 1),
        day = '' + now.getDate(),
        year = now.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        dateString = [year, month, day].join('-');
    }
    function getSelected(){
        if (params.id === 'San Martin'){
            selectedLocal = 'San Martin';
        }
        if (params.id === 'Costa'){
            selectedLocal = 'Costa';
        }
        if (params.id === 'Güemes'){
            selectedLocal = 'Guemes';
        }
        if (params.id === 'Santa Fe'){
            selectedLocal = 'Santa Fe';
        }
    }

    function tablaDatos(){
        if (!estabaDia){
            const newTabla = {
                total: 0,
                tarjeta: 0,
                efectivo: 0,
                pagos: 0,
                gastos: 0,
                neto: 0,
                cambio: 0,
                sobrante: 0
            };
            register.forEach( reg => {
                //const reg = register[i];
                if (reg.doc.cambio){
                    newTabla.cambio = reg.doc.cambio;
                }
                if (reg.doc.amount){
                    newTabla.total += (reg.doc.type === 'Egreso' ? (-1 * parseInt(reg.doc.amount)) : parseInt(reg.doc.amount));
                    newTabla.neto += (reg.doc.type === 'Egreso' ? 0 : parseInt(reg.doc.amount));
                }
                if (reg.doc.type === "Ingreso"){
                    if (reg.tarjeta){
                        newTabla.tarjeta += parseInt(reg.doc.amount);
                    } else {
                        newTabla.efectivo += parseInt(reg.doc.amount);
                    }
                } else if (reg.doc.type === "Egreso") {
                    if (reg.sobrenombre){
                        newTabla.pagos += parseInt(reg.doc.amount);
                    } else {
                        newTabla.gastos += parseInt(reg.doc.amount);
                    }
                }
            });
            caja = newTabla;
        }
    }

    function tablaWorkers(){
        let tabla = {};
        console.log('inicia la tabla ')
        console.log(register);
        register.forEach(reg => {
            if (reg.doc.sobrenombre){
                if (tabla[reg.doc.sobrenombre] === undefined){
                    if (reg.doc.tipo === 'Perforación'){
                        tabla[reg.doc.sobrenombre] = {sobrenombre: reg.doc.sobrenombre, perfos: reg.doc.cantidad, tatuajes: 0, pagos: 0};
                    }
                    if (reg.doc.tipo === 'Tatuaje'){
                        tabla[reg.doc.sobrenombre] = {sobrenombre: reg.doc.sobrenombre, perfos: 0, tatuajes: 1, pagos: 0};
                    }
                    if (reg.doc.tipo === 'Pago'){
                        tabla[reg.doc.sobrenombre] = {sobrenombre: reg.doc.sobrenombre, perfos: 0, tatuajes: 0, pagos: reg.doc.amount};
                    }
                } else {
                    if (reg.doc.tipo === 'Perforación'){
                        tabla[reg.doc.sobrenombre].perfos += reg.doc.cantidad;
                    }
                    if (reg.doc.tipo === 'Tatuaje'){
                        tabla[reg.doc.sobrenombre].tatuajes += 1;
                    }
                    if (reg.doc.tipo === 'Pago'){
                        tabla[reg.doc.sobrenombre].pagos += reg.doc.amount;
                    }
                }
            }
        });
        trabajadores = tabla;
    }
    function getCajaActual(){
        superagent.get(`${ip}/caja:${selectedLocal}-${selectedDate}`)
        .set('Accept', 'application/json')
        .set('Authorization', `Basic ${authCode}`)
        .end((err, res)=>{
            console.log(res);
            if (res.ok){
                estabaDia = true;
                caja = res.body;
            } else {
                console.log('no hay caja');
            }
        })
        superagent.post(`${ip}/_partition/register/_all_docs?include_docs=true`)
        .set('Accept', 'application/json')
        .send({
            "selector":{
                "local": {"$eq": selectedLocal},
                "day": {"$eq": selectedDate}
            }
        })
        .set('Authorization', `Basic ${authCode}`)
        .end((err,res)=>{
            console.log(res.body.rows);
            register = res.body.rows.filter(el => el.doc && el.doc._id.includes(`register:${selectedLocal}-${selectedDate}`)).sort((a,b)=>{
                    let fechaA = new Date(a.doc.date);
                    let fechaB = new Date(b.doc.date);
                    if (fechaA - fechaB > 0){
                        return 1;
                    }
                    return -1;
                });
                console.log(register);
                tablaDatos();
                tablaWorkers();
                cargando = false;
        })
    }

    async function getNotas(){
        await superagent.get(`${ip}/nota:${selectedLocal}`)
        .set('Accept', 'application/json')
        .set('Accept', 'application/json')
        .set('Authorization', `Basic ${authCode}`)
        .end((err, res)=>{
            if (res.ok){
                nota = res.body.text;
            } else {
                console.log(err);
            }
        })
    }

    function cambiarFecha(newFecha){
        caja = null;
        estabaDia = false;
        let dateArray = newFecha.split('-');
        cargando = true;
        selectedDate = `${parseInt(dateArray[0])}-${parseInt(dateArray[1])}-${parseInt(dateArray[2])}`;
        getCajaActual();
    }

    onMount(()=>{
        cargando = true;
        parsedDate();
        getSelected();
        getCajaActual();
        getNotas();
    });

</script>
<div class="w-full p-2 flex flex-col items-center justify-start">
        <div class="w-full flex items-center p-4">
            <a href="#/locales" class="bg-red-500 text-white p-2 rounded shadow">
                Volver
            </a>
        </div>
        <div class="font-bold">Local: {params.id}</div>
        <div class="w-full mb-2">
            <input bind:value={dateString} on:change={(e) => cambiarFecha(e.target.value)} type="date" class="w-full p-2 shadow" />
        </div>
        {#if !cargando && caja}
        <div class="w-full p-4 bg-white shadow mb-2">
            <div class="flex items-center justify-between">
                <div class="w-full flex flex-col items-center justify-center">
                    <div class="text-xs font-bold">Neto</div>
                    <div class="font-bold">${caja.total}</div>
                </div>
                <div class="w-full flex flex-col items-center justify-center">
                    <div class="text-xs font-bold">Total</div>
                    <div class="font-bold">${caja.neto}</div>
                </div>
            </div>
            <div class="w-full h-px bg-gray-300 my-2"></div>
            <div class="flex items-center justify-between">
                <div class="w-full flex flex-col items-center justify-center">
                    <div class="text-xs font-bold">Tarjeta</div>
                    <div class="text-xs font-bold">${caja.tarjeta}</div>
                </div>
                <div class="w-full flex flex-col items-center justify-center">
                    <div class="text-xs font-bold">Efectivo</div>
                    <div class="text-xs font-bold">${caja.efectivo}</div>
                </div>
            </div>
            <div class="w-full h-px bg-gray-300 my-1"></div>
            <div class="flex items-center justify-between">
                <div class="w-full flex flex-col items-center justify-center">
                    <div class="text-xs font-bold">Gastos</div>
                    <div class="text-xs font-bold">${caja.gastos}</div>
                </div>
                <div class="w-full flex flex-col items-center justify-center">
                    <div class="text-xs font-bold">Pagos</div>
                    <div class="text-xs font-bold">${caja.pagos}</div>
                </div>
            </div>
            <div class="w-full h-px bg-gray-300 my-1"></div>
            <div class="flex items-center justify-between">
                <div class="w-full flex flex-col items-center justify-center">
                    <div class="text-xs font-bold">Sobrante</div>
                    <div class="text-xs font-bold">${caja.sobrante}</div>
                </div>
                <div class="w-full flex flex-col items-center justify-center">
                    <div class="text-xs font-bold">Cambio</div>
                    <div class="text-xs font-bold">${caja.cambio}</div>
                </div>
            </div>
        </div>
        <div class="w-full p-4 bg-white shadow mb-2 flex flex-col items-center justify-start">
            <div class="flex items-center justify-between font-bold">Notas</div>
        {#if nota}
            <div class="p-2 text-xs w-full h-32 overflow-y-scroll overflow-x-hidden bg-gray-100">
                {nota}
            </div>
        {/if}
        </div>
        <div class="w-full p-4 bg-white shadow mb-2 flex flex-col items-center justify-start">
            <div class="flex items-center justify-between font-bold">Empleados</div>
            {#each Object.values(trabajadores) as worker}
                <div class="w-full flex items-center justify-between">
                    <div class="flex flex flex-col items-center justify-center">
                        <div class="font-bold text-xs">Sobrenombre</div>
                        <div>{worker.sobrenombre}</div>
                    </div>
                    <div class="flex flex flex-col items-center justify-center">
                        <div class="font-bold text-xs">Tatuajes</div>
                        <div>{worker.tatuajes}</div>
                    </div>
                    <div class="flex flex flex-col items-center justify-center">
                        <div class="font-bold text-xs">Perforaciones</div>
                        <div>{worker.perfos}</div>
                    </div>
                    <div class="flex flex flex-col items-center justify-center">
                        <div class="font-bold text-xs">Pago</div>
                        <div>${worker.pagos}</div>
                    </div>
                </div>
            {/each}
        </div>

        <div class="w-full p-4 bg-white shadow mb-2 flex flex-col items-center justify-start">
            <div class="flex items-center justify-between font-bold">Historial</div>

            {#each register as reg}
                <div class="w-full flex items-center justify-between border-b border-gray-300 mb-2 py-2">
                    <div class="w-full flex items-center justify-start">
                        <div class="font-bold text-xs">{`${reg.doc.date[3]}:${(reg.doc.date[4] < 10 ? `0${reg.doc.date[4]}`: reg.doc.date[4])}hs`}</div>
                        <div class="text-xs ml-2">{reg.doc.desc}</div>
                    </div>
                    <div class="w-full flex items-center justify-end">
                        <div class="text-xs mr-2">{reg.doc.cantidad ? `x${reg.doc.cantidad}` : ''}</div>
                        <div class="font-bold text-xs">${(reg.doc.type === 'Egreso' ? '-' : '')}{reg.doc.amount}</div>
                    </div>
                </div>
            {/each}
        </div>
        {/if}
</div>
